var map = {
	"./symbol_0.png": "11ea",
	"./symbol_1.png": "f3f8",
	"./symbol_2.png": "4212",
	"./symbol_3.png": "d910",
	"./symbol_4.png": "0466",
	"./symbol_5.png": "ae67",
	"./symbol_6.png": "dedd",
	"./symbol_7.png": "8880",
	"./symbol_8.png": "8cd0",
	"./symbol_9.png": "f7aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69e3";